// imports
import * as $ from 'jquery';

let bookmarks;

(window as any).unloadEducations = unloadEducations;

export function initialize(): void {
    $('.js-load-educations').on('click', onShowEducations);
};

function unloadEducations(): void {
    bookmarks = null;
}

function onShowEducations(event: any, params: any): void {
    $(".pIMyEducations").addClass("selectedItem").show();
    $("#heromenu_myeducations").addClass("selectedItem").attr("aria-pressed", "true");

    $(".pILatestVisited").removeClass("selectedItem").hide();
    $(".pIMyFavorites").removeClass("selectedItem").hide();

    $("#heromenu_latestvisited").removeClass("selectedItem").attr("aria-pressed", "false");
    $("#heromenu_myfavourites").removeClass("selectedItem").attr("aria-pressed", "false");

    $(".hero-menu__header-list").animate({ scrollLeft: 0 }, 300);

}
